// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: AppFont;
  src: url('Figtree-Regular.ttf');
}
@font-face {
  font-family: AppFontMedium;
  src: url('Figtree-Medium.ttf');
}
@font-face {
  font-family: AppFontSemiBold;
  src: url('Figtree-SemiBold.ttf');
}
@font-face {
  font-family: AppFontBold;
  src: url('Figtree-Bold.ttf');
}
@font-face {
  font-family: AppFontLight;
  src: url('Figtree-Light.ttf');
}
@font-face {
  font-family: AppFontExtraBold;
  src: url('Figtree-ExtraBold.ttf');
}
:root {
  --ion-color-primary: #324650;
  --ion-color-primary-rgb: 50,70,80;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255,255,255;
  --ion-color-primary-shade: #2c3e46;
  --ion-color-primary-tint: #475962;
  --ion-color-secondary: #E6E1D7;
  --ion-color-secondary-rgb: 230,225,215;
  --ion-color-secondary-contrast: #000000;
  --ion-color-secondary-contrast-rgb: 0,0,0;
  --ion-color-secondary-shade: #cac6bd;
  --ion-color-secondary-tint: #e9e4db;
  --ion-color-tertiary: #96785F;
  --ion-color-tertiary-rgb: 150,120,95;
  --ion-color-tertiary-contrast: #000000;
  --ion-color-tertiary-contrast-rgb: 0,0,0;
  --ion-color-tertiary-shade: #846a54;
  --ion-color-tertiary-tint: #a1866f;
  --ion-color-success: #10dc60;
  --ion-color-success-rgb: 16, 220, 96;
  --ion-color-success-contrast: #ffffff;
  --ion-color-success-contrast-rgb: 255, 255, 255;
  --ion-color-success-shade: #0ec254;
  --ion-color-success-tint: #28e070;
  --ion-color-warning: #ffce00;
  --ion-color-warning-rgb: 255, 206, 0;
  --ion-color-warning-contrast: #ffffff;
  --ion-color-warning-contrast-rgb: 255, 255, 255;
  --ion-color-warning-shade: #e0b500;
  --ion-color-warning-tint: #ffd31a;
  --ion-color-danger: #f04141;
  --ion-color-danger-rgb: 245, 61, 61;
  --ion-color-danger-contrast: #ffffff;
  --ion-color-danger-contrast-rgb: 255, 255, 255;
  --ion-color-danger-shade: #d33939;
  --ion-color-danger-tint: #f25454;
  --ion-color-dark: #284128;
  --ion-color-dark-rgb: 40, 65, 40;
  --ion-color-dark-contrast: #ffffff;
  --ion-color-dark-contrast-rgb: 255, 255, 255;
  --ion-color-dark-shade: #233a23;
  --ion-color-dark-tint: #3e5440;
  --ion-color-medium: #41413F;
  --ion-color-medium-rgb: 65,65,63;
  --ion-color-medium-contrast: #ffffff;
  --ion-color-medium-contrast-rgb: 255,255,255;
  --ion-color-medium-shade: #393937;
  --ion-color-medium-tint: #545452;
  --ion-color-light: #f4f5f8;
  --ion-color-light-rgb: 244, 244, 244;
  --ion-color-light-contrast: #000000;
  --ion-color-light-contrast-rgb: 0, 0, 0;
  --ion-color-light-shade: #d7d8da;
  --ion-color-light-tint: #f5f6f9;
  --ion-color-second: #cda53c;
  --ion-color-second-rgb: 205, 165, 60;
  --ion-color-second-contrast: #284128;
  --ion-color-second-contrast-rgb: 40, 65, 40;
  --ion-color-second-shade: #b48f35;
  --ion-color-second-tint: #d3ae52;
  --ion-color-gray-light: #f5f5f5;
  --ion-color-gray-dark: #d4d4d4;
  --ion-color-gray-darkest: #1f1b1c;
  --ion-default-font: AppFont, serif !important;
  --ion-text-color: #284128;
  --quantity-selector-border-width: 1px;
  --quantity-selector-border-color: var(--ion-color-tertiary);
  --quantity-selector-height: 32px;
  --quantity-selector-background: #ffffff;
  --quantity-selector-text-color: var(--ion-color-tertiary);
  --quantity-rectangle-background: #ffffff;
  --quantity-font-size: 18px;
  --background-default: #fff;
  --icon-color: #284128;
  --color-black: #1A1A1A;
  --color-gray: #E6E6E6;
  --color-light-gray: #F5F3EF;
  --color-dark-gray: #656564;
  --color-white: #ffffff;
  --color-red: #c22120;
  --radius-default: 4px;
  --default-text-color: #373737;
  --outline-default: 0.5px solid #93939380;
  --outline-offset-default: -6px;
}

.ion-color-main-color {
  --ion-color-base: var(--ion-color-main);
  --ion-color-base-rgb: var(--ion-color-main-rgb);
  --ion-color-contrast: var(--ion-color-main-contrast);
  --ion-color-contrast-rgb: var(--ion-color-main-contrast-rgb);
  --ion-color-shade: var(--ion-color-main-shade);
  --ion-color-tint: var(--ion-color-main-tint);
}

.ion-color-second-color {
  --ion-color-base: var(--ion-color-second);
  --ion-color-base-rgb: var(--ion-color-second-rgb);
  --ion-color-contrast: var(--ion-color-second-contrast);
  --ion-color-contrast-rgb: var(--ion-color-second-contrast-rgb);
  --ion-color-shade: var(--ion-color-second-shade);
  --ion-color-tint: var(--ion-color-second-tint);
}

.ion-color-black {
  --ion-color-base: var(--ion-color-black);
  --ion-color-base-rgb: var(--ion-color-black);
  --ion-color-contrast: var(--ion-color-main-contrast);
  --ion-color-contrast-rgb: var(--ion-color-main-contrast-rgb);
  --ion-color-shade: var(--ion-color-main-shade);
  --ion-color-tint: var(--ion-color-main-tint);
}

html,
body {
  height: 100%;
  font-family: AppFont, sans-serif;
  color: var(--color-black);
}

h1,
h2,
h3,
h4 app-payment-success {
  font-family: AppFontBold, sans-serif;
  color: var(--color-black);
  letter-spacing: 0;
  line-height: 100%;
}

p,
span {
  margin: 0;
  font-family: AppFont;
  letter-spacing: 0;
  line-height: 100%;
}

body {
  margin: 0;
}

ion-label {
  color: var(--ion-color-label);
}

app-home {
  background: #284128 no-repeat center center/100% 100% !important;
  background-size: cover !important;
}
@media (max-width: 992px) {
  app-home {
    background: #284128 no-repeat center center/100% 100% !important;
  }
}
@media (min-width: 991px) {
  app-home {
    background: #284128 no-repeat center 127px/100% 100% !important;
  }
}
app-home ion-header {
  background: transparent;
}
app-home ion-content {
  background: transparent !important;
  --background: transparent !important;
}

app-menu {
  background: var(--background-default) no-repeat center top/100% !important;
}
app-menu ion-header {
  background: transparent;
}
app-menu ion-content {
  background: transparent !important;
  --background: transparent !important;
}

app-menu-modal ion-header {
  background: transparent;
}
app-menu-modal ion-content {
  background: transparent !important;
  --background: transparent !important;
}

app-payment-success {
  background-position: center top;
}
app-payment-success ion-content {
  background: transparent !important;
  --background: transparent !important;
}

.home-bg {
  --home-ink: #f7f2e7;
  --home-gold: var(--ion-color-secondary);
  --home-gold-deep: #9b7b22;
  --home-green: #0f2515;
  --home-green-mid: #18361f;
  --home-panel: rgba(10, 20, 12, 0.92);
  --home-line: rgba(205, 165, 60, 0.5);
  background: var(--ion-color-primary);
  background-size: cover !important;
  background-position: center bottom !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed !important;
  background-image: url('home_bg.png') !important;
  width: auto;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.home-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  mix-blend-mode: soft-light;
  opacity: 0.35;
  pointer-events: none;
}
.home-bg::after {
  content: "";
  position: absolute;
  inset: -30% 0 auto 0;
  height: 60%;
  background: radial-gradient(70% 70% at 50% 0%, rgba(205, 165, 60, 0.3), transparent 70%);
  pointer-events: none;
}

.header-row {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@media (min-width: 991px) {
  .header-row {
    height: 127px;
    padding-inline: 50px;
  }
}
.header-row .logo {
  display: none;
}
@media (min-width: 991px) {
  .header-row .logo {
    display: block;
    height: 58px;
    width: 291px;
  }
}
.header-row app-burger-btn {
  margin-left: auto;
  --icon-color: var(--ion-color-primary);
}
@media (height < 770px) {
  .header-row app-burger-btn {
    margin-right: 10px;
  }
}

ion-header {
  --background: var(--ion-color-tertiary);
  background: var(--ion-color-tertiary);
}

.content-row {
  height: 100%;
}
.content-row .content-col {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  padding: 70px 28px 30px;
  position: relative;
  z-index: 1;
}

.brand-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin: 10px 0 28px;
  color: var(--home-ink);
}
@media (height < 770px) {
  .brand-wrap {
    margin-bottom: 18px;
  }
}
@media (min-width: 991px) {
  .brand-wrap {
    margin-bottom: 16px;
  }
}

.brand-logo {
  width: 180px;
  text-align: center;
  object-fit: contain;
  margin: auto;
}

.brand-tagline {
  margin: 0;
  font-family: AppFontSemiBold;
  font-size: 12px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(205, 165, 60, 0.9);
}

.card {
  background: var(--ion-color-secondary);
  padding: 22px 20px 18px;
  margin: 0 auto;
  overflow: hidden;
  min-width: 300px;
  width: 100%;
  max-width: 375px;
  border: 1px solid var(--ion-color-secondary);
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(6px);
  border-radius: 8px;
}
@media (height < 770px) {
  .card {
    padding: 14px 14px 12px;
  }
}
.card .overlay {
  padding-bottom: 16px;
  padding-top: 0px;
  border-bottom: 1px solid rgba(205, 165, 60, 0.35);
  margin-bottom: 12px;
  position: relative;
}
.card .overlay img {
  width: 180px;
}
.card .overlay .pie-img {
  width: 100%;
  max-width: 185px;
  margin: 0px auto 0px;
  height: auto;
  filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.4));
}
@media (height < 770px) {
  .card .overlay .pie-img {
    padding: 0;
    width: 100%;
    max-width: 150px;
    margin: 0px auto;
    height: 76px;
  }
}
.card .button-wrap {
  text-align: center;
  cursor: pointer;
  padding-top: 10px;
}

ion-footer {
  --background: transparent;
  background: transparent;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  box-shadow: none;
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: max-content;
  margin: 0 auto;
  gap: 10px;
}
.footer-lang div {
  text-align: center;
  width: 84px;
  height: 44px;
  background: var(--ion-color-medium);
  border-radius: var(--radius-default);
  overflow: hidden;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: -moz-fit-content;
  width: fit-content;
  gap: 8px;
  min-width: 70px;
}
.footer-lang div p {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  color: #f7f2e7;
}
.footer-lang div .flag-avatar {
  width: 24px;
  height: 24px;
}
.footer-lang div .flag-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.footer-lang div ion-icon {
  height: 24px;
  width: 24px;
  border-radius: 100%;
}
.footer-lang div.selected {
  background: var(--ion-color-secondary);
}
.footer-lang div.selected p {
  color: var(--ion-color-primary);
}
.footer-lang div.selected ion-icon {
  border: 1px solid var(--ion-color-secondary);
}

.lang-block {
  padding-bottom: 25px;
}

.info-text {
  color: var(--home-ink);
  font-family: AppFont;
  font-weight: 400;
  font-size: 14px;
  line-height: 135%;
  text-align: center;
  vertical-align: middle;
  text-wrap: balance;
  margin-bottom: 10px;
}

.overlay-payment {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 6px;
  padding-bottom: 13px;
  border-top: 1px solid rgba(205, 165, 60, 0.35);
  border-bottom: 1px solid rgba(205, 165, 60, 0.35);
}
.overlay-payment .info-payment {
  font-family: AppFont;
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  text-align: center;
  margin-bottom: 8px;
  color: var(--default-text-color);
}
.overlay-payment .payment-icons {
  width: 100%;
  height: 16px;
}

.alergen-link {
  padding-top: 20px;
  cursor: pointer;
  color: var(--default-text-color);
  font-family: AppFont;
  font-size: 16px;
  line-height: 135%;
  letter-spacing: 0.01em;
  text-align: center;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-offset: 0%;
  text-decoration-thickness: 1px;
}

.select-preorder-container {
  padding-bottom: 20px;
}
.select-preorder-container p {
  padding: 20px;
  font-family: AppFont;
  font-weight: 500;
  font-size: 16px;
  line-height: 100%;
  vertical-align: middle;
}
.select-preorder-container ion-col.take_away {
  padding-left: 5px;
}
.select-preorder-container ion-col.take_away .select-preorder-img {
  padding: 30px 0;
}
.select-preorder-container ion-col.inside {
  padding-right: 5px;
}
.select-preorder-container ion-col .select-preorder-img {
  display: flex;
  justify-content: center;
  padding: 40px 0;
  border: 0.5px solid #939393;
  border-bottom: none;
}
.select-preorder-container ion-col ion-button {
  color: var(--color-black);
  font-family: AppFont;
  font-weight: 400;
  font-size: 14px;
  line-height: 135%;
  text-transform: capitalize;
  letter-spacing: 0.1px;
  border-radius: 1px;
}

.title {
  padding-block: 15px;
  width: 70%;
  margin: 0 auto;
  font-family: AppFont;
  font-size: 16px;
  line-height: 115%;
  letter-spacing: 0;
  text-align: center;
  color: var(--default-text-color);
}

.subtitle {
  display: block;
  font-family: AppFontSemiBold;
  font-size: 24px;
  color: #1d1d1b;
  text-wrap: balance;
  margin-bottom: 10px;
}
@media (height < 770px) {
  .subtitle {
    font-size: 12px;
  }
}

.preorder-title {
  font-family: AppFont;
  font-size: 16px;
  font-weight: 500;
  color: #1d1d1b;
}
@media (height < 770px) {
  .preorder-title {
    font-size: 14px;
  }
}

@media (height < 770px) {
  .btn {
    height: 44px !important;
  }
}

.pointer {
  cursor: pointer;
}

.inputs-block {
  margin: 0 auto;
}

.input-block {
  position: relative;
  width: 100%;
  margin: 0 auto 12px;
}
.input-block ion-label {
  position: absolute;
  top: 3px;
  left: 50%;
  transform: translate(-50%, 0%);
  font-family: AppFontLight;
  font-size: 9px;
  line-height: 150%;
  letter-spacing: 0.01em;
  width: max-content;
  color: #4d5053;
}

ion-item {
  border: 1px solid #c0c0bf;
  border-radius: 3px;
  --background: #ffffff !important;
  --min-height: 30px;
  --inner-padding-end: 0;
}
ion-item.input-error {
  border: 0.8px solid #cc0e0e;
}
ion-item ion-input {
  font-family: AppFontMedium, sans-serif;
  font-size: 13px;
  line-height: 127%;
  letter-spacing: 0.01em;
  color: #050b05;
  text-align: center !important;
  --padding-top: 1px;
  min-height: 35px;
}
ion-item ion-input ion-label {
  align-self: center;
}
ion-item:has(ion-checkbox) {
  border: none;
}
ion-item .input-error {
  border: 0.8px solid #cc0e0e;
}

.error-text-block {
  position: absolute;
  left: 0;
  bottom: -13px;
  width: max-content;
}
.error-text-block .error-text {
  font-family: AppFontLight;
  font-size: 8px;
  line-height: 135%;
  letter-spacing: 0;
  vertical-align: middle;
  margin: 0;
  color: #d13b2c;
}

.privacy-checkbox {
  width: 80%;
  margin: 0 auto;
  --background: transparent !important;
}
.privacy-checkbox .checkbox-label {
  margin: 0;
  font-family: AppFont;
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0em;
  text-align: left;
  color: #3C3C3B;
}
.privacy-checkbox ion-checkbox {
  height: 20px;
  --background: transparent;
  --background-checked: #1ea45a;
  --border-color: #3C3C3B;
  --border-color-checked: #1ea45a;
  --border-width: 1px;
  --checkmark-color: var(--ion-color-secondary);
  --checkmark-width: 3px;
  --border-radius: 3px;
  --size: 20px;
  margin: 0;
  margin-right: 10px;
}
.privacy-checkbox ion-checkbox::part(container) {
  background: transparent;
}
.privacy-checkbox ion-checkbox.checkbox-checked::part(container) {
  background: #09A650;
  border-color: #09A650;
}
.privacy-checkbox ion-checkbox.checkbox-checked::part(mark) {
  color: #0f2a18;
}`, "",{"version":3,"sources":["webpack://./src/theme/bistro.scss","webpack://./src/app/pages/home/home.page.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAMA;EACE,oBAAA;EACA,+BAAA;ACLF;ADOA;EACE,0BAAA;EACA,8BAAA;ACLF;ADOA;EACE,4BAAA;EACA,gCAAA;ACLF;ADOA;EACE,wBAAA;EACA,4BAAA;ACLF;ADOA;EACE,yBAAA;EACA,6BAAA;ACLF;ADOA;EACE,6BAAA;EACA,iCAAA;ACLF;ADQA;EACE,4BAAA;EACA,iCAAA;EACA,qCAAA;EACA,6CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,8BAAA;EACA,sCAAA;EACA,uCAAA;EACA,yCAAA;EACA,oCAAA;EACA,mCAAA;EAEA,6BAAA;EACA,oCAAA;EACA,sCAAA;EACA,wCAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,4BAAA;EACA,oCAAA;EACA,qCAAA;EACA,+CAAA;EACA,kCAAA;EACA,iCAAA;EAEA,2BAAA;EACA,mCAAA;EACA,oCAAA;EACA,8CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,yBAAA;EACA,gCAAA;EACA,kCAAA;EACA,4CAAA;EACA,+BAAA;EACA,8BAAA;EAEA,2BAAA;EACA,gCAAA;EACA,oCAAA;EACA,4CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,0BAAA;EACA,oCAAA;EACA,mCAAA;EACA,uCAAA;EACA,gCAAA;EACA,+BAAA;EAEA,2BAAA;EACA,oCAAA;EACA,oCAAA;EACA,2CAAA;EACA,iCAAA;EACA,gCAAA;EAEA,+BAAA;EACA,8BAAA;EACA,iCAAA;EAEA,6CAAA;EACA,yBAAA;EACA,qCAAA;EACA,2DAAA;EACA,gCAAA;EACA,uCAAA;EACA,yDAAA;EACA,wCAAA;EACA,0BAAA;EAEA,0BAAA;EACA,qBAAA;EACA,sBAAA;EACA,qBAAA;EACA,2BAAA;EACA,0BAAA;EACA,sBAAA;EACA,oBAAA;EACA,qBAAA;EACA,6BAAA;EACA,wCAAA;EACA,8BAAA;AClBF;;ADqBA;EACE,uCAAA;EACA,+CAAA;EACA,oDAAA;EACA,4DAAA;EACA,8CAAA;EACA,4CAAA;AClBF;;ADqBA;EACE,yCAAA;EACA,iDAAA;EACA,sDAAA;EACA,8DAAA;EACA,gDAAA;EACA,8CAAA;AClBF;;ADqBA;EACE,wCAAA;EACA,4CAAA;EACA,oDAAA;EACA,4DAAA;EACA,8CAAA;EACA,4CAAA;AClBF;;ADqBA;;EAEE,YAAA;EACA,gCAAA;EACA,yBAAA;AClBF;;ADoBA;;;;EAIE,oCAAA;EACA,yBAAA;EACA,iBAAA;EACA,iBAAA;ACjBF;;ADoBA;;EAEE,SAAA;EACA,oBAAA;EACA,iBAAA;EACA,iBAAA;ACjBF;;ADoBA;EACE,SAAA;ACjBF;;ADoBA;EACE,6BAAA;ACjBF;;ADoBA;EACE,gEAAA;EACA,iCAAA;ACjBF;ACvKE;EFsLF;IAKI,gEAAA;EChBF;AACF;AClLE;EF4LF;IAQI,+DAAA;ECdF;AACF;ADgBE;EACE,uBAAA;ACdJ;ADiBE;EACE,kCAAA;EACA,oCAAA;ACfJ;;ADmBA;EACE,0EAAA;AChBF;ADkBE;EACE,uBAAA;AChBJ;ADmBE;EACE,kCAAA;EACA,oCAAA;ACjBJ;;ADsBE;EACE,uBAAA;ACnBJ;ADsBE;EACE,kCAAA;EACA,oCAAA;ACpBJ;;ADwBA;EACE,+BAAA;ACrBF;AD4BE;EACE,kCAAA;EACA,oCAAA;AC1BJ;;AAvNA;EACE,mBAAA;EACA,uCAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,oCAAA;EACA,oCAAA;EAEA,oCAAA;EACA,iCAAA;EACA,6CAAA;EACA,uCAAA;EACA,uCAAA;EACA,+CAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAyNF;AAvNE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,0BAAA;EACA,aAAA;EACA,oBAAA;AAyNJ;AAtNE;EACE,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,WAAA;EACA,wFAAA;EACA,oBAAA;AAwNJ;;AApNA;EACE,YAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAuNF;ACpQE;EDyCF;IAMI,aAAA;IACA,oBAAA;EAyNF;AACF;AAvNE;EACE,aAAA;AAyNJ;AC7QE;EDmDA;IAGI,cAAA;IACA,YAAA;IACA,YAAA;EA2NJ;AACF;AAxNE;EACE,iBAAA;EACA,sCAAA;AA0NJ;AAxNI;EAJF;IAKI,kBAAA;EA2NJ;AACF;;AAvNA;EACE,uCAAA;EACA,qCAAA;AA0NF;;AAvNA;EACE,YAAA;AA0NF;AAxNE;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;AA0NJ;;AAtNA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,sBAAA;AAyNF;AAvNE;EARF;IASI,mBAAA;EA0NF;AACF;AC7TE;EDyFF;IAaI,mBAAA;EA2NF;AACF;;AAxNA;EACE,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AA2NF;;AAxNA;EACE,SAAA;EACA,4BAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,8BAAA;AA2NF;;AAxNA;EACE,sCAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,4CAAA;EACA,2CAAA;EACA,0BAAA;EACA,kBAAA;AA2NF;AAzNE;EAbF;IAcI,uBAAA;EA4NF;AACF;AA1NE;EACE,oBAAA;EACA,gBAAA;EACA,iDAAA;EACA,mBAAA;EACA,kBAAA;AA4NJ;AA1NI;EACE,YAAA;AA4NN;AAzNI;EACE,WAAA;EACA,gBAAA;EACA,oBAAA;EACA,YAAA;EACA,mDAAA;AA2NN;AAzNM;EAPF;IAQI,UAAA;IACA,WAAA;IACA,gBAAA;IACA,gBAAA;IACA,YAAA;EA4NN;AACF;AAxNE;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;AA0NJ;;AAtNA;EACE,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;AAyNF;;AAtNA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;AAyNF;AAvNE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,oCAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,QAAA;EACA,eAAA;AAyNJ;AAvNI;EACE,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,cAAA;AAwNN;AArNI;EACE,WAAA;EACA,YAAA;AAuNN;AApNI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAsNN;AAnNI;EACE,YAAA;EACA,WAAA;EACA,mBAAA;AAqNN;AAhNI;EACE,sCAAA;AAkNN;AAhNM;EACE,+BAAA;AAkNR;AA/MM;EACE,4CAAA;AAiNR;;AA3MA;EACE,oBAAA;AA8MF;;AA3MA;EACE,sBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,mBAAA;AA6MF;;AA1MA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,oBAAA;EACA,8CAAA;EACA,iDAAA;AA6MF;AA3ME;EACE,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gCAAA;AA6MJ;AA1ME;EACE,WAAA;EACA,YAAA;AA4MJ;;AAxMA;EACE,iBAAA;EACA,eAAA;EACA,gCAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,0BAAA;EACA,4BAAA;EACA,0BAAA;EACA,8BAAA;AA0MF;;AAvMA;EACE,oBAAA;AA0MF;AAxME;EACE,aAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AA0MJ;AAtMI;EACE,iBAAA;AAwMN;AAtMM;EACE,eAAA;AAwMR;AApMI;EACE,kBAAA;AAsMN;AAnMI;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,2BAAA;EACA,mBAAA;AAqMN;AAlMI;EACE,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;AAoMN;;AA/LA;EACE,mBAAA;EACA,UAAA;EACA,cAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gCAAA;AAkMF;;AA/LA;EACE,cAAA;EACA,4BAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;AAkMF;AAhME;EARF;IASI,eAAA;EAmMF;AACF;;AAhMA;EACE,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAmMF;AAjME;EANF;IAOI,eAAA;EAoMF;AACF;;AAhME;EADF;IAEI,uBAAA;EAoMF;AACF;;AAjMA;EACE,eAAA;AAoMF;;AAjMA;EACE,cAAA;AAoMF;;AAjMA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;AAoMF;AAlME;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EAEA,cAAA;AAmMJ;;AA/LA;EACE,yBAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;EACA,sBAAA;AAkMF;AAhME;EACE,2BAAA;AAkMJ;AA/LE;EACE,sCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,6BAAA;EAEA,kBAAA;EACA,gBAAA;AAgMJ;AA9LI;EACE,kBAAA;AAgMN;AAzLE;EACE,YAAA;AA2LJ;AAxLE;EACE,2BAAA;AA0LJ;;AAtLA;EACE,kBAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;AAyLF;AAvLE;EACE,yBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,SAAA;EACA,cAAA;AAyLJ;;AArLA;EACE,UAAA;EACA,cAAA;EACA,oCAAA;AAwLF;AAtLE;EACE,SAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;AAwLJ;AArLE;EACE,YAAA;EACA,yBAAA;EACA,6BAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,6CAAA;EACA,sBAAA;EACA,oBAAA;EACA,YAAA;EAEA,SAAA;EACA,kBAAA;AAsLJ;AAnLE;EACE,uBAAA;AAqLJ;AAlLE;EACE,mBAAA;EACA,qBAAA;AAoLJ;AAjLE;EACE,cAAA;AAmLJ","sourcesContent":["@use '@angular/material' as mat;\n@use './mixins' as mixins;\n\n$brand: 'bistro';\n$brandAssets: '/assets/#{$brand}';\n\n@font-face {\n  font-family: AppFont;\n  src: url('../assets/fonts/Figtree-Regular.ttf');\n}\n@font-face {\n  font-family: AppFontMedium;\n  src: url('../assets/fonts/Figtree-Medium.ttf');\n}\n@font-face {\n  font-family: AppFontSemiBold;\n  src: url('../assets/fonts/Figtree-SemiBold.ttf');\n}\n@font-face {\n  font-family: AppFontBold;\n  src: url('../assets/fonts/Figtree-Bold.ttf');\n}\n@font-face {\n  font-family: AppFontLight;\n  src: url('../assets/fonts/Figtree-Light.ttf');\n}\n@font-face {\n  font-family: AppFontExtraBold;\n  src: url('../assets/fonts/Figtree-ExtraBold.ttf');\n}\n\n:root {\n  --ion-color-primary: #324650;\n  --ion-color-primary-rgb: 50,70,80;\n  --ion-color-primary-contrast: #ffffff;\n  --ion-color-primary-contrast-rgb: 255,255,255;\n  --ion-color-primary-shade: #2c3e46;\n  --ion-color-primary-tint: #475962;\n\n  --ion-color-secondary: #E6E1D7;\n  --ion-color-secondary-rgb: 230,225,215;\n  --ion-color-secondary-contrast: #000000;\n  --ion-color-secondary-contrast-rgb: 0,0,0;\n  --ion-color-secondary-shade: #cac6bd;\n  --ion-color-secondary-tint: #e9e4db;\n\n  --ion-color-tertiary: #96785F;\n  --ion-color-tertiary-rgb: 150,120,95;\n  --ion-color-tertiary-contrast: #000000;\n  --ion-color-tertiary-contrast-rgb: 0,0,0;\n  --ion-color-tertiary-shade: #846a54;\n  --ion-color-tertiary-tint: #a1866f;\n\n  --ion-color-success: #10dc60;\n  --ion-color-success-rgb: 16, 220, 96;\n  --ion-color-success-contrast: #ffffff;\n  --ion-color-success-contrast-rgb: 255, 255, 255;\n  --ion-color-success-shade: #0ec254;\n  --ion-color-success-tint: #28e070;\n\n  --ion-color-warning: #ffce00;\n  --ion-color-warning-rgb: 255, 206, 0;\n  --ion-color-warning-contrast: #ffffff;\n  --ion-color-warning-contrast-rgb: 255, 255, 255;\n  --ion-color-warning-shade: #e0b500;\n  --ion-color-warning-tint: #ffd31a;\n\n  --ion-color-danger: #f04141;\n  --ion-color-danger-rgb: 245, 61, 61;\n  --ion-color-danger-contrast: #ffffff;\n  --ion-color-danger-contrast-rgb: 255, 255, 255;\n  --ion-color-danger-shade: #d33939;\n  --ion-color-danger-tint: #f25454;\n\n  --ion-color-dark: #284128;\n  --ion-color-dark-rgb: 40, 65, 40;\n  --ion-color-dark-contrast: #ffffff;\n  --ion-color-dark-contrast-rgb: 255, 255, 255;\n  --ion-color-dark-shade: #233a23;\n  --ion-color-dark-tint: #3e5440;\n\n  --ion-color-medium: #41413F;\n  --ion-color-medium-rgb: 65,65,63;\n  --ion-color-medium-contrast: #ffffff;\n  --ion-color-medium-contrast-rgb: 255,255,255;\n  --ion-color-medium-shade: #393937;\n  --ion-color-medium-tint: #545452;\n\n  --ion-color-light: #f4f5f8;\n  --ion-color-light-rgb: 244, 244, 244;\n  --ion-color-light-contrast: #000000;\n  --ion-color-light-contrast-rgb: 0, 0, 0;\n  --ion-color-light-shade: #d7d8da;\n  --ion-color-light-tint: #f5f6f9;\n\n  --ion-color-second: #cda53c;\n  --ion-color-second-rgb: 205, 165, 60;\n  --ion-color-second-contrast: #284128;\n  --ion-color-second-contrast-rgb: 40, 65, 40;\n  --ion-color-second-shade: #b48f35;\n  --ion-color-second-tint: #d3ae52;\n\n  --ion-color-gray-light: #f5f5f5;\n  --ion-color-gray-dark: #d4d4d4;\n  --ion-color-gray-darkest: #1f1b1c;\n\n  --ion-default-font: AppFont, serif !important;\n  --ion-text-color: #284128;\n  --quantity-selector-border-width: 1px;\n  --quantity-selector-border-color: var(--ion-color-tertiary);\n  --quantity-selector-height: 32px;\n  --quantity-selector-background: #ffffff;\n  --quantity-selector-text-color: var(--ion-color-tertiary);\n  --quantity-rectangle-background: #ffffff;\n  --quantity-font-size: 18px;\n\n  --background-default: #fff;\n  --icon-color: #284128;\n  --color-black: #1A1A1A;\n  --color-gray: #E6E6E6;\n  --color-light-gray: #F5F3EF;\n  --color-dark-gray: #656564;\n  --color-white: #ffffff;\n  --color-red: #c22120;\n  --radius-default: 4px;\n  --default-text-color: #373737;\n  --outline-default: 0.5px solid #93939380;\n  --outline-offset-default: -6px;\n}\n\n.ion-color-main-color {\n  --ion-color-base: var(--ion-color-main);\n  --ion-color-base-rgb: var(--ion-color-main-rgb);\n  --ion-color-contrast: var(--ion-color-main-contrast);\n  --ion-color-contrast-rgb: var(--ion-color-main-contrast-rgb);\n  --ion-color-shade: var(--ion-color-main-shade);\n  --ion-color-tint: var(--ion-color-main-tint);\n}\n\n.ion-color-second-color {\n  --ion-color-base: var(--ion-color-second);\n  --ion-color-base-rgb: var(--ion-color-second-rgb);\n  --ion-color-contrast: var(--ion-color-second-contrast);\n  --ion-color-contrast-rgb: var(--ion-color-second-contrast-rgb);\n  --ion-color-shade: var(--ion-color-second-shade);\n  --ion-color-tint: var(--ion-color-second-tint);\n}\n\n.ion-color-black {\n  --ion-color-base: var(--ion-color-black);\n  --ion-color-base-rgb: var(--ion-color-black);\n  --ion-color-contrast: var(--ion-color-main-contrast);\n  --ion-color-contrast-rgb: var(--ion-color-main-contrast-rgb);\n  --ion-color-shade: var(--ion-color-main-shade);\n  --ion-color-tint: var(--ion-color-main-tint);\n}\n\nhtml,\nbody {\n  height: 100%;\n  font-family: AppFont, sans-serif;\n  color: var(--color-black);\n}\nh1,\nh2,\nh3,\nh4 app-payment-success {\n  font-family: AppFontBold, sans-serif;\n  color: var(--color-black);\n  letter-spacing: 0;\n  line-height: 100%;\n}\n\np,\nspan {\n  margin: 0;\n  font-family: AppFont;\n  letter-spacing: 0;\n  line-height: 100%;\n}\n\nbody {\n  margin: 0;\n}\n\nion-label {\n  color: var(--ion-color-label);\n}\n\napp-home {\n  background: #284128 no-repeat center center / 100% 100% !important;\n  background-size: cover !important;\n\n  @include mixins.mobile {\n    background: #284128 no-repeat center center / 100% 100% !important;\n  }\n  @include mixins.desktop {\n    background: #284128 no-repeat center 127px / 100% 100% !important;\n  }\n\n  ion-header {\n    background: transparent;\n  }\n\n  ion-content {\n    background: transparent !important;\n    --background: transparent !important;\n  }\n}\n\napp-menu {\n  background: var(--background-default) no-repeat center top / 100% !important;\n\n  ion-header {\n    background: transparent;\n  }\n\n  ion-content {\n    background: transparent !important;\n    --background: transparent !important;\n  }\n}\n\napp-menu-modal {\n  ion-header {\n    background: transparent;\n  }\n\n  ion-content {\n    background: transparent !important;\n    --background: transparent !important;\n  }\n}\n\napp-payment-success {\n  background-position: center top;\n  @include mixins.mobile {\n    // background: var(--ion-color-primary) !important;\n  }\n  @include mixins.desktop {\n    // background: #fff url('../assets/anton_and_anni/background_home_desk.jpg') no-repeat center 0px / 100% 100% !important;\n  }\n  ion-content {\n    background: transparent !important;\n    --background: transparent !important;\n  }\n}\n","@use '../../../theme/mixins' as *;\n@use '../../../theme/bistro' as *;\n\n.home-bg {\n  --home-ink: #f7f2e7;\n  --home-gold: var(--ion-color-secondary);\n  --home-gold-deep: #9b7b22;\n  --home-green: #0f2515;\n  --home-green-mid: #18361f;\n  --home-panel: rgba(10, 20, 12, 0.92);\n  --home-line: rgba(205, 165, 60, 0.5);\n\n  background: var(--ion-color-primary);\n  background-size: cover !important;\n  background-position: center bottom !important;\n  background-repeat: no-repeat !important;\n  background-attachment: fixed !important;\n  background-image: url('../../../assets/bistro/home_bg.png') !important;\n  width: auto;\n  height: 100%;\n  position: relative;\n  overflow: hidden;\n\n  &::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    mix-blend-mode: soft-light;\n    opacity: 0.35;\n    pointer-events: none;\n  }\n\n  &::after {\n    content: '';\n    position: absolute;\n    inset: -30% 0 auto 0;\n    height: 60%;\n    background: radial-gradient(70% 70% at 50% 0%, rgba(205, 165, 60, 0.3), transparent 70%);\n    pointer-events: none;\n  }\n}\n\n.header-row {\n  height: 60px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  @include desktop {\n    height: 127px;\n    padding-inline: 50px;\n  }\n\n  .logo {\n    display: none;\n    @include desktop {\n      display: block;\n      height: 58px;\n      width: 291px;\n    }\n  }\n\n  app-burger-btn {\n    margin-left: auto;\n    --icon-color: var(--ion-color-primary);\n\n    @media (height < 770px) {\n      margin-right: 10px;\n    }\n  }\n}\n\nion-header {\n  --background: var(--ion-color-tertiary);\n  background: var(--ion-color-tertiary);\n}\n\n.content-row {\n  height: 100%;\n\n  .content-col {\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    align-items: center;\n    padding: 70px 28px 30px;\n    position: relative;\n    z-index: 1;\n  }\n}\n\n.brand-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  margin: 10px 0 28px;\n  color: var(--home-ink);\n\n  @media (height < 770px) {\n    margin-bottom: 18px;\n  }\n\n  @include desktop {\n    margin-bottom: 16px;\n  }\n}\n\n.brand-logo {\n  width: 180px;\n  text-align: center;\n  object-fit: contain;\n  margin: auto;\n}\n\n.brand-tagline {\n  margin: 0;\n  font-family: AppFontSemiBold;\n  font-size: 12px;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: rgba(205, 165, 60, 0.9);\n}\n\n.card {\n  background: var(--ion-color-secondary);\n  padding: 22px 20px 18px;\n  margin: 0 auto;\n  overflow: hidden;\n  min-width: 300px;\n  width: 100%;\n  max-width: 375px;\n  border: 1px solid var(--ion-color-secondary);\n  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);\n  backdrop-filter: blur(6px);\n  border-radius: 8px;\n\n  @media (height < 770px) {\n    padding: 14px 14px 12px;\n  }\n\n  .overlay {\n    padding-bottom: 16px;\n    padding-top: 0px;\n    border-bottom: 1px solid rgba(205, 165, 60, 0.35);\n    margin-bottom: 12px;\n    position: relative;\n\n    img {\n      width: 180px;\n    }\n\n    .pie-img {\n      width: 100%;\n      max-width: 185px;\n      margin: 0px auto 0px;\n      height: auto;\n      filter: drop-shadow(0 10px 18px rgba(0, 0, 0, 0.4));\n\n      @media (height < 770px) {\n        padding: 0;\n        width: 100%;\n        max-width: 150px;\n        margin: 0px auto;\n        height: 76px;\n      }\n    }\n  }\n\n  .button-wrap {\n    text-align: center;\n    cursor: pointer;\n    padding-top: 10px;\n  }\n}\n\nion-footer {\n  --background: transparent;\n  background: transparent;\n  overflow: hidden;\n  position: absolute;\n  bottom: 0;\n  box-shadow: none;\n}\n\n.footer-lang {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: max-content;\n  margin: 0 auto;\n  gap: 10px;\n\n  div {\n    text-align: center;\n    width: 84px;\n    height: 44px;\n    background: var(--ion-color-medium);\n    border-radius: var(--radius-default);\n    overflow: hidden;\n    padding: 8px 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: fit-content;\n    gap: 8px;\n    min-width: 70px;\n\n    p {\n      font-family: AppFontMedium;\n      font-size: 14px;\n      line-height: 100%;\n      letter-spacing: 0%;\n      vertical-align: middle;\n      text-transform: uppercase;\n\n      color: #f7f2e7;\n    }\n\n    .flag-avatar {\n      width: 24px;\n      height: 24px;\n    }\n\n    .flag-avatar img {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    ion-icon {\n      height: 24px;\n      width: 24px;\n      border-radius: 100%;\n    }\n  }\n\n  div {\n    &.selected {\n      background: var(--ion-color-secondary);\n\n      p {\n        color: var(--ion-color-primary);\n      }\n\n      ion-icon {\n        border: 1px solid var(--ion-color-secondary);\n      }\n    }\n  }\n}\n\n.lang-block {\n  padding-bottom: 25px;\n}\n\n.info-text {\n  color: var(--home-ink);\n  font-family: AppFont;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 135%;\n  text-align: center;\n  vertical-align: middle;\n  text-wrap: balance;\n\n  margin-bottom: 10px;\n}\n\n.overlay-payment {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding-top: 6px;\n  padding-bottom: 13px;\n  border-top: 1px solid rgba(205, 165, 60, 0.35);\n  border-bottom: 1px solid rgba(205, 165, 60, 0.35);\n\n  .info-payment {\n    font-family: AppFont;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 150%;\n    text-align: center;\n    margin-bottom: 8px;\n    color: var(--default-text-color);\n  }\n\n  .payment-icons {\n    width: 100%;\n    height: 16px;\n  }\n}\n\n.alergen-link {\n  padding-top: 20px;\n  cursor: pointer;\n  color: var(--default-text-color);\n\n  font-family: AppFont;\n  font-size: 16px;\n  line-height: 135%;\n  letter-spacing: 0.01em;\n  text-align: center;\n  text-decoration: underline;\n  text-decoration-style: solid;\n  text-decoration-offset: 0%;\n  text-decoration-thickness: 1px;\n}\n\n.select-preorder-container {\n  padding-bottom: 20px;\n\n  p {\n    padding: 20px;\n    font-family: AppFont;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 100%;\n    vertical-align: middle;\n  }\n\n  ion-col {\n    &.take_away {\n      padding-left: 5px;\n\n      .select-preorder-img {\n        padding: 30px 0;\n      }\n    }\n\n    &.inside {\n      padding-right: 5px;\n    }\n\n    .select-preorder-img {\n      display: flex;\n      justify-content: center;\n      padding: 40px 0;\n      border: 0.5px solid #939393;\n      border-bottom: none;\n    }\n\n    ion-button {\n      color: var(--color-black);\n      font-family: AppFont;\n      font-weight: 400;\n      font-size: 14px;\n      line-height: 135%;\n      text-transform: capitalize;\n      letter-spacing: 0.1px;\n      border-radius: 1px;\n    }\n  }\n}\n\n.title {\n  padding-block: 15px;\n  width: 70%;\n  margin: 0 auto;\n  font-family: AppFont;\n  font-size: 16px;\n  line-height: 115%;\n  letter-spacing: 0;\n  text-align: center;\n  color: var(--default-text-color);\n}\n\n.subtitle {\n  display: block;\n  font-family: AppFontSemiBold;\n  font-size: 24px;\n  color: #1d1d1b;\n  text-wrap: balance;\n  margin-bottom: 10px;\n\n  @media (height < 770px) {\n    font-size: 12px;\n  }\n}\n\n.preorder-title {\n  font-family: AppFont;\n  font-size: 16px;\n  font-weight: 500;\n  color: #1d1d1b;\n\n  @media (height < 770px) {\n    font-size: 14px;\n  }\n}\n\n.btn {\n  @media (height < 770px) {\n    height: 44px !important;\n  }\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.inputs-block {\n  margin: 0 auto;\n}\n\n.input-block {\n  position: relative;\n  width: 100%;\n  margin: 0 auto 12px;\n\n  ion-label {\n    position: absolute;\n    top: 3px;\n    left: 50%;\n    transform: translate(-50%, 0%);\n    font-family: AppFontLight;\n    font-size: 9px;\n    line-height: 150%;\n    letter-spacing: 0.01em;\n    width: max-content;\n\n    color: #4d5053;\n  }\n}\n\nion-item {\n  border: 1px solid #c0c0bf;\n  border-radius: 3px;\n  --background: #ffffff !important;\n  --min-height: 30px;\n  --inner-padding-end: 0;\n\n  &.input-error {\n    border: 0.8px solid #cc0e0e;\n  }\n\n  ion-input {\n    font-family: AppFontMedium, sans-serif;\n    font-size: 13px;\n    line-height: 127%;\n    letter-spacing: 0.01em;\n    color: #050b05;\n    text-align: center !important;\n\n    --padding-top: 1px;\n    min-height: 35px;\n\n    ion-label {\n      align-self: center;\n    }\n  }\n\n  &:not(:has(ion-checkbox)) {\n  }\n\n  &:has(ion-checkbox) {\n    border: none;\n  }\n\n  .input-error {\n    border: 0.8px solid #cc0e0e;\n  }\n}\n\n.error-text-block {\n  position: absolute;\n  left: 0;\n  bottom: -13px;\n  width: max-content;\n\n  .error-text {\n    font-family: AppFontLight;\n    font-size: 8px;\n    line-height: 135%;\n    letter-spacing: 0;\n    vertical-align: middle;\n    margin: 0;\n    color: #d13b2c;\n  }\n}\n\n.privacy-checkbox {\n  width: 80%;\n  margin: 0 auto;\n  --background: transparent !important;\n\n  .checkbox-label {\n    margin: 0;\n    font-family: AppFont;\n    font-size: 12px;\n    line-height: 135%;\n    letter-spacing: 0em;\n    text-align: left;\n    color: #3C3C3B;\n  }\n\n  ion-checkbox {\n    height: 20px;\n    --background: transparent;\n    --background-checked: #1ea45a;\n    --border-color: #3C3C3B;\n    --border-color-checked: #1ea45a;\n    --border-width: 1px;\n    --checkmark-color: var(--ion-color-secondary);\n    --checkmark-width: 3px;\n    --border-radius: 3px;\n    --size: 20px;\n\n    margin: 0;\n    margin-right: 10px;\n  }\n\n  ion-checkbox::part(container) {\n    background: transparent;\n  }\n\n  ion-checkbox.checkbox-checked::part(container) {\n    background: #09A650;\n    border-color: #09A650;\n  }\n\n  ion-checkbox.checkbox-checked::part(mark) {\n    color: #0f2a18;\n  }\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
